/**
 * Runs `task` one at a time, collapsing a burst of triggers into a single follow-up run.
 *
 * Reorder writes carry the whole order, so two in flight at once can complete out of order and leave
 * the older one stored - the DOM, the database and the export would then disagree. Triggers arriving
 * mid-run set a flag instead of starting a second request; one more run follows, reading whatever the
 * DOM says by then. `task` receives a predicate telling it whether such a follow-up is already
 * pending, so it can skip echoing an answer that is already stale.
 *
 * @param {(isSuperseded: () => boolean) => Promise<void>} task
 * @returns {() => Promise<void>}
 */
export function createReorderWriteQueue(task) {
    let running = false;
    let pending = false;

    return async function trigger() {
        if (running) {
            pending = true;
            return;
        }

        running = true;
        try {
            do {
                pending = false;
                await task(() => pending);
            } while (pending);
        } finally {
            running = false;
        }
    };
}
